import axiosInstance from '@api/axios.ts';
import { urls } from '@api/urls.ts';
import {
  DocumentGeneratorTemplate,
  DocumentTemplateVersion,
  DocumentTemplateVersionHTMLContent,
} from '@app/types/document-generator-template';
import { DuplicateDocumentTemplateFormFields } from '@features/admin-multi-document-agent/utils/demand-letter/duplicate-template-validator';

export const deleteDocumentGeneratorTemplate = async (id: number) => {
  const response = await axiosInstance.delete(
    urls.documentGeneratorTemplate.byId(id)
  );

  return response.data;
};

export const updateDocumentGeneratorTemplate = async (
  id: number,
  data: Partial<DocumentGeneratorTemplate>
): Promise<DocumentGeneratorTemplate> => {
  const response = await axiosInstance.patch(
    urls.documentGeneratorTemplate.byId(id),
    data
  );

  return response.data;
};

export const updateDocumentGeneratorTemplateOrder = async (
  id: number,
  direction: 'up' | 'down'
): Promise<DocumentGeneratorTemplate> => {
  const response = await axiosInstance.patch(
    urls.documentGeneratorTemplate.updateOrder(id),
    { direction }
  );

  return response.data;
};

export const updateDocumentTemplateVersion = async (
  id: number,
  data: any
): Promise<DocumentTemplateVersion> => {
  const response = await axiosInstance.patch(
    urls.documentGeneratorVersion.byId(id),
    data
  );

  return response.data;
};

export const generateDocumentTemplateVersion = async (
  id: number
): Promise<void> => {
  const response = await axiosInstance.post(
    urls.documentGeneratorVersion.generate(id)
  );

  return response.data;
};

export const getDocumentTemplateVersionHTMLContent = async (
  id: number
): Promise<DocumentTemplateVersionHTMLContent> => {
  const response = await axiosInstance.get(
    urls.documentGeneratorVersion.getHtmlContent(id)
  );

  return response.data;
};

export const duplicateDocumentTemplate = async (
  id: number,
  body: DuplicateDocumentTemplateFormFields
): Promise<DocumentGeneratorTemplate> => {
  const response = await axiosInstance.post(
    urls.documentGeneratorTemplate.duplicate(id),
    body
  );

  return response.data;
};
